import { Pipe, PipeTransform } from '@angular/core';
import { LocationProduct } from 'src/app/features/charging-station-location/charging-station-location-model';

@Pipe({
  name: 'translateLocationProduct',
})
export class TranslateLocationProductPipe implements PipeTransform {
  transform(value: LocationProduct | null): string;
  transform(
    value: Array<{ index: number | string; name: number | string; value: number | string; label: string | number }>
  ): Array<{ index: number | string; name: string; value: number | string; label: string }>;
  transform(
    value: Array<{ index: number | string; name: number | string; value: number | string; label: string | number }> | LocationProduct | null
  ): string | Array<{ index: number | string; name: string; value: number | string; label: string }> {
    if (Array.isArray(value)) {
      return value
        .map(item => {
          const key = String(item.value) as keyof typeof LOCATION_PRODUCT_NAMES;
          return {
            index: item.index,
            name: LOCATION_PRODUCT_NAMES[key] || '',
            value: item.value,
            label: LOCATION_PRODUCT_NAMES[key] || '',
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label));
    }

    return value ? LOCATION_PRODUCT_NAMES[String(value) as keyof typeof LOCATION_PRODUCT_NAMES] || '' : '';
  }
}

const LOCATION_PRODUCT_NAMES: Record<LocationProduct, string> = {
  OkTotal: 'OK total',
  Eje: 'Eje',
  LejeMedOkMaaler: 'Leje m. OK-måler',
  LejeUdenOkMaaler: 'Leje u. OK-måler',
  KWhMedOkMaaler: 'kWh m. OK-måler',
  KWhUdenOkMaaler: 'kWh u. OK-måler',
  Haandteringsgebyr: 'Håndteringsgebyr',
  Kickback: 'Kick-back',
  DAB: 'DAB',
};
